import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SmsMessagingDialogComponent } from './sms-messaging-dialog/sms-messaging-dialog.component';

@Component({
  selector: 'oiq-sms-messaging',
  templateUrl: './sms-messaging.component.html',
  styleUrls: ['./sms-messaging.component.scss'],
  standalone: false,
})
export class SmsMessagingComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    const dialogRef = this.dialog.open(SmsMessagingDialogComponent);
  }
}
